
export const defaultAddr = {
	id: 0,
	street1: '',
	street2: '',
	city: '',
	postal_code: '',
	region: '',
	country: '',
}